<template>
  <basic-card>
    <template #header>{{ actualDefinition.name }}</template>
    <svg style="background-color: white; width: 100%; height: 100vh;" ref="chartRender"/>
  </basic-card>
</template>

<script>
import Loader from "@/components/Loader";
import BasicCard from "@/components/layout/BasicCard";
import {mapGetters} from "vuex";
import * as d3 from 'd3'

export default {
  name: "CashflowHeatMapView",
  components: {Loader, BasicCard},
  props: {
    header: String,
    contentHTML: String
  },
  computed: {
    actualReport() {
      return this.report()
    },
    ...mapGetters({
      report: 'cashflowReports/report',
      reportDefinition: 'cashflowReportDefinitions/cashflowReportDefinition'
    })
  },
  data:
      function () {
        return {
          internalReport: {},
          loading: true,
          reportId: "",
          actualDefinition: null
        }
      },
  watch: {
    '$route': {
      async handler(from, to) {
        this.loading = true;
        this.reportId = this.$route.params.report;
        this.$set(this, 'actualDefinition', this.$_.cloneDeep(this.reportDefinition(this.reportId)));
        await this.$store.dispatch("cashflowReports/reloadReport", {reportId: this.reportId});
        this.internalReport = this.report(this.reportId);
        this.loading = false;
        this.generateReport();
      },
      immediate: true
    }
  },
  methods: {
    generateReport() {
      //d3.select(this.$refs.chartRender)
      let hierarchy = d3.hierarchy(this.internalReport.root, d => Object.keys(d.children).map(key => {
        const children = d.children[key];
        children.id = key;
        return children
      }))
    }
  },
  async mounted() {

  }
}
</script>

<style scoped>

</style>